import { render, staticRenderFns } from "./UploadForm.vue?vue&type=template&id=768c4be8&scoped=true&"
import script from "./UploadForm.vue?vue&type=script&lang=ts&"
export * from "./UploadForm.vue?vue&type=script&lang=ts&"
import style0 from "./UploadForm.vue?vue&type=style&index=0&id=768c4be8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c4be8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VBtn,VCard,VFlex,VLayout,VTextField})
